var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Spinner_svg__a)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2250,
    height: 2250,
    x: -1125,
    y: -1125,
    transform: "translate(8 8)scale(.008)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 180deg at 50% 50%,#959595) 0deg,360deg",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 13.6A5.6 5.6 0 1 0 8 2.4a5.6 5.6 0 0 0 0 11.2",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.52941179275512695,\"g\":0.35686275362968445,\"b\":0.96862745285034180,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.52941179275512695,\"g\":0.35686275362968445,\"b\":0.96862745285034180,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":16.0,\"m01\":6.9938221258780686e-07,\"m02\":-6.9938221258780686e-07,\"m10\":-6.9938221258780686e-07,\"m11\":16.0,\"m12\":0.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.811,
    cy: 7.999,
    r: 1.188,
    fill: "#fff",
    transform: "rotate(-90 14.811 8)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Spinner_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 13.6A5.6 5.6 0 1 0 8 2.4a5.6 5.6 0 0 0 0 11.2"
  })))));
};
export default SvgSpinner;